import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import {SxProps, Theme, Typography} from '@mui/material'
import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../localization'

type DeletedStoppageWarningProps = {
  sx?: SxProps<Theme>
}

export const DeletedStoppageWarning: FC<DeletedStoppageWarningProps> = ({sx}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <Typography variant="body2" color="error" display="flex" alignItems="center" gap={0.5} sx={sx}>
      <WarningAmberOutlinedIcon />
      {t('label.stoppageWasDeleted')}
    </Typography>
  )
}
